// Widget raccourci : bouton d'action rapide (placeholder V1).
import { Plus } from "lucide-react";
import { Button } from "../../components/ui/button";

export default function ShortcutWidget({ widgetId, title, description }) {
  return (
    <div
      className="rounded-xl p-5 h-full flex flex-col items-center justify-center gap-2"
      style={{ background: "var(--oh-bg-elevated)", border: "1px solid var(--oh-border)" }}
      data-testid={`widget-shortcut-${widgetId}`}
    >
      <Button
        size="sm"
        className="gap-2"
        aria-label={title || "Nouveau dossier"}
      >
        <Plus className="w-4 h-4" />
        {title || "Nouveau dossier"}
      </Button>
      {description && (
        <p className="text-xs text-center" style={{ color: "var(--oh-text-muted)" }}>
          {description}
        </p>
      )}
    </div>
  );
}
